import { render, staticRenderFns } from "./EditCommon.vue?vue&type=template&id=299253aa&scoped=true"
import script from "./EditCommon.vue?vue&type=script&lang=js"
export * from "./EditCommon.vue?vue&type=script&lang=js"
import style0 from "./EditCommon.vue?vue&type=style&index=0&id=299253aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "299253aa",
  null
  
)

export default component.exports